// Sortaballs palette — 10 colors (a–j). d and g are two-color checker fills
// (they read better than a flat gradient); the rest are radial gradients.

import type { Palette } from "../shared-sortaballs/types"

export const PALETTE: Palette = {
	// red
	a: { className: "sa-col--a", color: "var(--ball-a)", type: "gradient" },
	// green
	b: { className: "sa-col--b", color: "var(--ball-b)", type: "gradient" },
	// purple
	c: { className: "sa-col--c", color: "var(--ball-c)", type: "gradient" },
	// orange + deep navy taper (checker)
	d: { className: "sa-col--d", color: "var(--ball-d-checker)", square: "var(--ball-d-checker-square)", type: "checker" },
	// pink
	e: { className: "sa-col--e", color: "var(--ball-d)", type: "gradient" },
	// silver
	f: { className: "sa-col--f", color: "var(--ball-e)", type: "gradient" },
	// azure + yellow taper (checker)
	g: { className: "sa-col--g", color: "var(--ball-g-checker)", square: "var(--ball-g-checker-square)", type: "checker" },
	// slate
	h: { className: "sa-col--h", color: "var(--ball-f)", type: "gradient" },
	// yellow
	i: { className: "sa-col--i", color: "var(--ball-g)", type: "gradient" },
	// lime
	j: { className: "sa-col--j", color: "var(--ball-h)", type: "gradient" },
}
